import React from 'react';
import { useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';
import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/dist/locale-data/en';
import '@formatjs/intl-relativetimeformat/dist/locale-data/it';

import enMessages from './messages/en';
import itMessages from './messages/it';

const allMessages = {
  en: enMessages,
  it: itMessages,
};

//language selector
export default function I18nProvider({ children }) {
  let locale = useSelector(({ i18n }) => i18n.lang);

  // Extract language code (e.g., "en-US" -> "en")
  const languageCode = locale.split('-')[0];
  // Check if the language code is supported
  const supportedLocale = Object.keys(allMessages).includes(languageCode)
    ? languageCode
    : 'it';

  const messages = allMessages[supportedLocale];

  return (
    <IntlProvider locale={supportedLocale} messages={messages}>
      {children}
    </IntlProvider>
  );
}
